export const STANDARD_RADIUS = '0.4rem';
export const STANDARD_SPACING = 12;
export const HEADER_HEIGHT = '11.1rem';
export const HEADER_HEIGHT_XS = '6.5rem';
